import type { TFunction } from "i18next";
import { z } from "zod";

export const createNotificationSchema = (t: TFunction) =>
  z.object({
    title: z.string().trim().min(1, t("notification.validation.title_required")),
    content: z.string().trim().min(1, t("notification.validation.content_required")),
    alert_type_id: z.string().trim().min(1, t("notification.validation.alert_type_required")),
    timezone: z.string().trim().min(1, t("notification.validation.timezone_required")),
    is_pinned: z.boolean(),
  });

export type CreateNotificationSchema = ReturnType<typeof createNotificationSchema>;
export type CreateNotificationFormValues = z.output<CreateNotificationSchema>;
